export default __webpack_public_path__ + "static/media/ELIKSIR-00507.c994654a.JPG";